var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnCours(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg8",
    viewBox: "0 0 194.0719 194.07187",
    height: "194.07187mm",
    width: "194.0719mm",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.1753719,-0.39264468)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(14.375696,0,0,14.375696,5.5814479,-8.9501489)",
    id: "g826",
    style: {
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      clipRule: "evenodd",
      fill: "#a4d233",
      fillRule: "evenodd"
    },
    d: "m 7,2.1499 c -2.89508,0 -5.25,2.35492 -5.25,5.25 0,2.8951 2.35492,5.25 5.25,5.25 2.89508,0 5.25,-2.3549 5.25,-5.25 0,-2.89508 -2.35492,-5.25 -5.25,-5.25 m 0,12 c -3.7217,0 -6.75,-3.0283 -6.75,-6.75 0,-3.7217 3.0283,-6.749998 6.75,-6.749998 3.7217,0 6.75,3.028298 6.75,6.749998 0,3.7217 -3.0283,6.75 -6.75,6.75",
    id: "path815"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(15.003781,0,0,15.003781,45.434609,35.388295)",
    id: "g839",
    style: {
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      clipRule: "evenodd",
      fill: "#a4d233",
      fillRule: "evenodd"
    },
    d: "m 3.15631,6.71691 c -0.18712,0 -0.37425,-0.06975 -0.51937,-0.20925 l -1.40625,-1.35 C 0.931815,4.87079 0.922065,4.39604 1.20894,4.09754 1.49581,3.79866 1.97056,3.78779 2.26944,4.07579 l 0.8715,0.83662 2.574,-2.62124 c 0.29025,-0.2955 0.76462,-0.3 1.0605,-0.00938 0.2955,0.29025 0.3,0.765 0.00975,1.0605 l -3.09375,3.15 C 3.54444,6.64191 3.35056,6.71691 3.15631,6.71691 Z",
    id: "path828"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnCours);
export default __webpack_public_path__ + "static/media/EnCours.87668edda799afa947861300c6929f53.svg";
export { ForwardRef as ReactComponent };